<ng-container page-top-buttons>
  <wlm-grid-buttons
    *ngIf="gridSettings"
    [(gridSettings)]="gridSettings"
    [grid]="genericGrid"
    [gridName]="gridName"
  >
    <ng-template wlmGridButtonsThirdSlot let-isContainerCollapsed="isContainerCollapsed">
      <button wlmCollapsibleButton [showLabel]="isContainerCollapsed">
        <mat-icon svgIcon="create-group"></mat-icon>
      </button>
      <button wlmCollapsibleButton [disabled]="!selectedGroup" [showLabel]="isContainerCollapsed">
        <mat-icon svgIcon="remove-group"></mat-icon>
      </button>
      <button wlmCollapsibleButton [disabled]="!selectedGroup" [showLabel]="isContainerCollapsed">
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </ng-template>
  </wlm-grid-buttons>
</ng-container>

<ng-container page-content>
  <wlm-local-grid
    #genericGrid
    class="groups-grid"
    [gridSettings]="gridSettings"
    [gridData]="gridData"
    (selectedItemChanged)="getSelectedGroup($event)"
  >
  </wlm-local-grid>

  <div>
    <h3>Separator</h3>
  </div>
  <hr class="local-separator" />

  <wlm-profile-dialogs-hierarchy-grid
    class="dialogs-grid"
    *ngIf="selectedGroup"
    [group]="selectedGroup"
    fullSize="true"
  ></wlm-profile-dialogs-hierarchy-grid>
</ng-container>
